<mat-drawer-container style="background: var(--background); display: initial;">
  <mat-drawer #drawer mode="over" position="end" style="width: 640px;background: var(--background)">
    <app-history-in-app-messages (copyMessage)="copyCurrentMessage($event)"></app-history-in-app-messages>
  </mat-drawer>
  <form [formGroup]="allForm" style="display: flex;">


    <div style="flex: 1;padding: 0 40px">

      <div style="display: flex;justify-content: space-between;margin-bottom: 32px;margin-top: 32px">

        <div class="title-large" data-testid="pageTitle" style="display: flex;align-items: center; gap: 8px">
          <span (click)="onBackClick.emit()" class="material-symbols-rounded"
                style="cursor: pointer;padding: 6px">west</span>
          @if (data().currentInAppMessage) {
            Edit app message
          } @else {
            New app message
          }
        </div>

        <div style="display: flex;align-items: center; gap:8px">

          <img [ngSrc]="'../'+Bu.getBu(data().bu).flagUrl" alt="flag" height="24" width="24">
          {{ Bu.getBu(data().bu).buName }}
        </div>

      </div>

      <div data-testid="englishMessage" style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_uk.png" sizes="24" width="24">
          English message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="englishTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="englishLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="englishMessage" rows="3"></textarea>
          </div>
        </div>
      </div>


      <div data-testid="swedishMessage" style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_sweden.svg" sizes="24" width="24">
          Swedish message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="swedishTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="swedishLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="swedishMessage" rows="3"></textarea>
          </div>
        </div>
      </div>


      <div data-testid="norwegianMessage" style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_norway.svg" sizes="24" width="24">
          Norwegian message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="norwegianTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="norwegianLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="norwegianMessage" rows="3"></textarea>
          </div>
        </div>
      </div>


      <div data-testid="germanMessage" style="margin-bottom:40px">
        <div class="title-small" style="gap: 8px;display: flex;align-items: center;margin-bottom: 24px">
          <img height="24" ngSrc="assets/ic_germany.svg" sizes="24" width="24">
          German message
        </div>

        <div style="display: flex;flex-direction: column;gap: 12px;width: 100%">
          <div style="display: flex; gap:12px">
            <div class="form-group" style="flex: 1">
              <label>Title</label>
              <input formControlName="germanTitle">
            </div>

            <div class="form-group" style="flex: 1">
              <label>Link label</label>
              <input formControlName="germanLabel">
            </div>
          </div>

          <div class="form-group">
            <label>Text</label>
            <textarea formControlName="germanMessage" rows="3"></textarea>
          </div>
        </div>
      </div>

    </div>


    <div style="flex: 1;background: var(--card-background);padding: 0 40px;">


      <div class="title-large" style="margin-bottom: 32px;margin-top: 32px">
        Settings
      </div>

      <div style="display: flex; gap:16px">
        <div class="form-group" style="width: 100%">
          <label>Start date</label>
          <div style="display: flex;gap: 8px;width: 100%">

            <div style="position: relative; flex: 1">
              <select (change)="onScheduledStartDateToggled($event)" formControlName="scheduledStart"
                      style="width: 100%">
                <option [value]="false">Immediately</option>
                <option [value]="true">Scheduled</option>
              </select>
              <svg fill="none" height="8" style="position: absolute;right:16px;top: 20px" viewBox="0 0 12 8" width="12"
                   xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd"
                      d="M0.399587 0.837087C0.765704 0.470971 1.3593 0.470971 1.72541 0.837087L6.0625 5.17417L10.3996 0.837087C10.7657 0.470971 11.3593 0.470971 11.7254 0.837087C12.0915 1.2032 12.0915 1.7968 11.7254 2.16291L6.72541 7.16291C6.3593 7.52903 5.7657 7.52903 5.39959 7.16291L0.399587 2.16291C0.0334709 1.7968 0.0334709 1.2032 0.399587 0.837087Z"
                      fill="#333333"
                      fill-rule="evenodd"/>
              </svg>


            </div>

            <div style="position: relative; flex: 1;display: flex">
              <input [matDatepicker]="datepicker" formControlName="startDate" style="width: 100%">
              <mat-datepicker #datepicker/>
              <mat-datepicker-toggle [for]="datepicker" matIconSuffix
                                     style="position: absolute;right:8px;top: 4px"></mat-datepicker-toggle>

            </div>
            <div style="flex: 1;display: flex">
              <input [matTimepicker]="timepicker" formControlName="startTime" style="width:100%">
              <mat-timepicker #timepicker/>
            </div>
          </div>

        </div>

      </div>

      <div style="display: flex;gap: 16px">
        <div class="form-group" style="width: 100%">
          <label>End date</label>

          <div style="display: flex;gap:8px;width: 100%">

            <div style="flex: 1;position: relative">

              <select (change)="onScheduledEndDateToggled($event)" formControlName="scheduledEnd" style="width: 100%">
                <option [value]="false">No end date</option>
                <option [value]="true">Scheduled</option>
              </select>


              <svg fill="none" height="8" style="position: absolute;right:16px;top: 20px; z-index: 0" viewBox="0 0 12 8"
                   width="12" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd"
                      d="M0.399587 0.837087C0.765704 0.470971 1.3593 0.470971 1.72541 0.837087L6.0625 5.17417L10.3996 0.837087C10.7657 0.470971 11.3593 0.470971 11.7254 0.837087C12.0915 1.2032 12.0915 1.7968 11.7254 2.16291L6.72541 7.16291C6.3593 7.52903 5.7657 7.52903 5.39959 7.16291L0.399587 2.16291C0.0334709 1.7968 0.0334709 1.2032 0.399587 0.837087Z"
                      fill="#333333"
                      fill-rule="evenodd"/>
              </svg>
            </div>


            <div style="position: relative;flex: 1;display: flex">
              <input [matDatepicker]="datepickerEnd" formControlName="endDate" style="width: 100%">
              <mat-datepicker #datepickerEnd/>
              <mat-datepicker-toggle [for]="datepickerEnd" matSuffix style="position: absolute;right:8px;top: 4px"/>
            </div>

            <div style="flex: 1;display: flex">
              <input [matTimepicker]="timepickerEnd" formControlName="endTime" matInput style="width: 100%">
              <mat-timepicker #timepickerEnd/>
            </div>
          </div>

        </div>

      </div>

      <div style="display: flex;gap:12px;">
        <div class="form-group" style="flex: 1">
          <label>Version condition</label>
          <select formControlName="versionCondition">
            <option [ngValue]="0">Disabled</option>
            <option [ngValue]="1">Smaller than</option>
            <option [ngValue]="2">Equal</option>
            <option [ngValue]="3">Larger than</option>
          </select>
        </div>

        <div class="form-group" style="flex: 1;">
          <label>Version number</label>
          <input formControlName="versionNumber">
        </div>
      </div>

      <div class="form-group">
        <label>Visible</label>
        <select formControlName="displayRoute">
          <option [value]="''">All</option>
          <option [value]="'map'">Map page</option>
          <option [value]="'/start-charging'">Start charging page</option>
          <option [value]="'history'">History page</option>
          <option [value]="'/payments'">Payments page</option>
          <option [value]="'profile'">Settings page</option>
          <option [value]="'/station-page'">Station page</option>
        </select>
      </div>

      <div class="form-group">
        <label>Operating System</label>
        <select formControlName="os">
          <option value="All">All</option>
          <option value="Android">Android</option>
          <option value="iOS">iOS</option>
        </select>
      </div>

      <div class="form-group">
        <label>Target audience</label>
        <div>
          <p>
            <input formControlName="subscriptionFlexible" type="checkbox">Mer flexible
          </p>
          <p>
            <input formControlName="subscriptionEnergy" type="checkbox">Mer energy
          </p>
          <p>
            <input formControlName="subscriptionDropIn" type="checkbox">Drop-in
          </p>
        </div>
      </div>

      <div class="form-group">
        <label>Message functions</label>
        <div>
          <p>
            <input formControlName="dismissible" type="checkbox">Dismissible
          </p>
          <p>
            <input formControlName="link" type="checkbox">Enable external link below (paired with "Link label” field)
          </p>
        </div>
      </div>

      <div class="form-group">
        <label for="link">Url</label>
        <input formControlName="externalUrl" id="link">
      </div>

    </div>
  </form>

  @if (loading()) {
    <mat-spinner diameter="40"
                 style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);"></mat-spinner>
  }

  <div class="fab-container">
    <div style="display: flex;gap: 8px">
      <button (click)="drawer.toggle()" class="secondary-button" data-testid="previousMessagesButton">Previous
        messages
      </button>
      <button (click)="translateWithAI()" class="secondary-button" data-testid="autoTranslateButton">Auto translate
      </button>
    </div>
    <button (click)="createMessage()" [disabled]="!allForm.valid" class="primary-button" data-testid="publishButton">
      Publish
    </button>
  </div>
</mat-drawer-container>
